export const ENTITY_TYPE_RESTAURANT = 'restaurant';
export const ENTITY_TYPE_STORE = 'store';

export const RESTAURANT_HOME_TAB = 'dine-in';
export const SUPERMARKET_HOME_TAB = 'pos';

/** Whether the header/dashboard is in supermarket (store) mode. */
export function isSupermarketContext() {
  return getEntityType() === ENTITY_TYPE_STORE;
}

export function isRestaurantContext() {
  return getEntityType() === ENTITY_TYPE_RESTAURANT;
}

export function getEntityType() {
  try {
    const stored = localStorage.getItem('headerEntityType');
    return stored === ENTITY_TYPE_STORE ? ENTITY_TYPE_STORE : ENTITY_TYPE_RESTAURANT;
  } catch {
    return ENTITY_TYPE_RESTAURANT;
  }
}

export function setEntityType(type) {
  const normalized =
    type === ENTITY_TYPE_STORE ? ENTITY_TYPE_STORE : ENTITY_TYPE_RESTAURANT;
  try {
    localStorage.setItem('headerEntityType', normalized);
  } catch {
    // ignore
  }
  return normalized;
}

export function getDefaultHomeTab() {
  return isSupermarketContext() ? SUPERMARKET_HOME_TAB : RESTAURANT_HOME_TAB;
}

export function getActiveStoreId() {
  try {
    return localStorage.getItem('storeId') || '';
  } catch {
    return '';
  }
}

export function getActiveRestaurantId() {
  try {
    return localStorage.getItem('restaurantId') || '';
  } catch {
    return '';
  }
}

/** Store context for /business/user (delivery agent) — not only headerEntityType. */
export function resolveEmployeeStoreContext(user) {
  if (getEntityType() === ENTITY_TYPE_STORE) return true;
  if (getActiveStoreId()) return true;
  if (!user || typeof user !== 'object') return false;

  const type = String(user.type ?? user.Type ?? '').trim().toUpperCase();
  if (type === 'STR' || type === ENTITY_TYPE_STORE.toUpperCase()) return true;

  const storeId = user.storeId ?? user.store_id ?? user.Store_Id;
  return storeId != null && String(storeId).trim() !== '';
}

export function applyStoreSessionFromUser(user) {
  if (!user || typeof user !== 'object') return false;
  const storeId = user.storeId ?? user.store_id ?? user.Store_Id;
  if (storeId == null || String(storeId).trim() === '') return false;

  try {
    localStorage.setItem('storeId', String(storeId));
    const storeName = user.storeName ?? user.store_name ?? user.Store_Name;
    if (storeName) localStorage.setItem('storeName', String(storeName));
    setEntityType(ENTITY_TYPE_STORE);
  } catch {
    return false;
  }
  return true;
}

/** Full navigation to home with the correct default tab for the current entity type. */
export function goToEntityHome(type = getEntityType()) {
  const tab =
    type === ENTITY_TYPE_STORE ? SUPERMARKET_HOME_TAB : RESTAURANT_HOME_TAB;
  window.location.href = `/business/admin?tab=${tab}`;
}
